import React from 'react';

import { createRoot } from 'react-dom/client';

import SearchFiltersDialog from '../components/SearchFiltersDialog';
import getSearchFiltersDialogMountParent from './getSearchFiltersDialogMountParent';

/** Show search filters dialog */
export default function showESearchFiltersDialog({
  stackAboveModals = false,
  ...props
} = {}) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('exportDialogWrapper');

  const parent = getSearchFiltersDialogMountParent(stackAboveModals);
  parent.appendChild($wrapper);
  const root = createRoot($wrapper);

  function destroy() {
    root.unmount();
    if ($wrapper.parentNode) {
      $wrapper.parentNode.removeChild($wrapper);
    }
  }

  root.render(<SearchFiltersDialog destroy={destroy} {...props} />);
}
